module.exports = __webpack_public_path__ + "img/top.47b392f7.png";